import { useEffect, useState } from 'react';

// Service
import BillingService from '../../services/billingService';
import { utils } from '../../utils/utils';

//Hooks
import useUser from '../user/useUser';

const useSellerSales = () => {
    const { branch } = useUser();
    const [loading, setLoading] = useState(false);
    const [sellerSales, setSellerSales] = useState([]);

    const [filters, setFilters] = useState({
        branchCode: branch.code,
        from: utils.getDateNow(),
        to: utils.getDateNow()
    });
    
    useEffect(() => {
        if(branch.code)
            setFilters(state => ({ ...state, branchCode: branch.code }))
    }, [branch])

    useEffect(() => {   
        const mapSellerSales = (res) => {
            const result = res.map(r => ({
                ...r,
                file: r.seller.code,
                name: r.seller.userName,
            }));

            if (result.length > 0) {
                result.push({
                    file: 'Total:',
                    totalAmount: result.reduce((a, b) => a + b.totalAmount, 0),
                    quantity: result.reduce((a, b) => a + b.quantity, 0),
                });
            }

            return result;
        }

        const getSellerSales = () => {
            setLoading(true);
            return BillingService
                .GetSellerSales(filters)
                .then(res => setSellerSales(mapSellerSales(res)))
                .finally(() => setLoading(false))            
        }

        if (!loading && filters.branchCode)
            getSellerSales();         
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    const changeFilters = ( filters ) =>
        setFilters(state => ({ ...state, ...filters }))

    return {
        sellerSales,
        filters,
        loading,
        setFilters: changeFilters,
    };
}

export default useSellerSales;